export function NormalUser() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="layers-three-01" clipPath="url(#clip0_4428_3801)">
        <path
          id="Icon"
          d="M1.33203 8.00037L7.76018 11.2144C7.84764 11.2582 7.89137 11.28 7.93723 11.2886C7.97785 11.2963 8.01954 11.2963 8.06016 11.2886C8.10603 11.28 8.14976 11.2582 8.23721 11.2144L14.6654 8.00037M1.33203 11.3337L7.76018 14.5478C7.84764 14.5915 7.89137 14.6134 7.93723 14.622C7.97785 14.6296 8.01954 14.6296 8.06016 14.622C8.10603 14.6134 8.14976 14.5915 8.23721 14.5478L14.6654 11.3337M1.33203 4.66704L7.76018 1.45296C7.84764 1.40923 7.89137 1.38737 7.93723 1.37876C7.97785 1.37114 8.01954 1.37114 8.06016 1.37876C8.10603 1.38737 8.14976 1.40923 8.23721 1.45296L14.6654 4.66704L8.23721 7.88111C8.14976 7.92484 8.10603 7.9467 8.06016 7.95531C8.01954 7.96293 7.97785 7.96293 7.93723 7.95531C7.89137 7.9467 7.84764 7.92484 7.76018 7.88111L1.33203 4.66704Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4428_3801">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
